<template>
  <li class="dk-navbar-search dk-navbar__nav-item">
    <button
      :disabled="!!isSearchPage"
      @click="$emit('toggle')"
      class="dk-navbar__search dk-navbar__nav-item-link"
      :aria-label="$t('search.input.label')"
    >
      <DKIcon icon="search-bold" :size="20"></DKIcon>
    </button>
    <Megamenu
      v-show="isExpanded"
      type="secondary"
      :isTransparent="true"
      :isExpanded="true"
      :fixHeight="true"
    >
      <DKSearchArea>
        <DKSearch
          id="navbar-search"
          type="secondary"
          :searchTerm="searchTerm"
          :placeholder="
            isDesktop
              ? $t('search.input.placeholder')
              : $t('search.input.label')
          "
          @search="onSearch"
          @remove="onRemove"
        ></DKSearch>
      </DKSearchArea>
    </Megamenu>
  </li>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { DKIcon } from '@dormakaba/dormakaba-components';
import Megamenu from '@/components/navbar/Megamenu.vue';
import DKSearchArea from '@/components/search/DKSearchArea.vue';
import DKSearch from '@/components/search/DKSearch.vue';
import { useMq } from 'vue3-mq';

@Component({
  components: {
    DKIcon,
    Megamenu,
    DKSearchArea,
    DKSearch,
  },
  emits: ['toggle', 'search', 'clear', 'close'],
})
export default class NavbarSearch extends Vue {
  @Prop({ default: false }) isExpanded!: boolean;

  searchTerm: string | string[] = '';

  get isSearchPage() {
    return (this.$route.name as string) === 'search-page';
  }

  get isDesktop(): boolean {
    return this.$isDesktop(this.$mq);
  }

  created() {
    this.$mq = useMq();
  }

  mounted() {
    this.searchTerm = this.$route.query.q as string;

    this.$watch(
      () => this.$route.query.q as string,
      (searchTerm: string) => (this.searchTerm = searchTerm)
    );

    this.$watch(
      () => this.$route,
      () => {
        this.$emit('close');
      }
    );
  }

  onSearch(searchTerm: string) {
    this.searchTerm = searchTerm;
    this.$router.push({
      path: `/${this.$route.params.locale}/search`,
      query: { q: searchTerm },
    });
    this.$emit('search', this.searchTerm);
  }

  onRemove() {
    this.searchTerm = '';
    this.$router.push({ query: {} });
    this.$emit('clear');
  }
}
</script>

<style lang="postcss" scoped>
.dk-navbar__search {
  @apply h-full;
}

.dk-megamenu--fix-height {
  height: auto;
}
</style>
